module.exports = __webpack_public_path__ + "static/media/arrow-right.da8778ed.png";